module.exports = __webpack_public_path__ + "img/safe_tool_7.323d80e0.jpg";